import styled from '@emotion/styled';
import type {Device} from 'prolink-connect/lib/types';

type Props = {
  device: Device;
  className?: string;
};

const DeviceInfo = ({device, className}: Props) => (
  <div className={className}>
    <DeviceName>{device.name}</DeviceName>
    <IPAddr>{device.ip.address}</IPAddr>
  </div>
);

const DeviceName = styled('div')`
  font-size: 0.6rem;
  font-weight: 600;
`;

const IPAddr = styled('div')`
  font-size: 0.55rem;
  color: ${p => p.theme.subText};
`;

export default DeviceInfo;
